<template>
  <section class="checkout-section">
    <div class="checkout-section__skip">
      <NavButton
        :text="data.excursions.bookWithoutExcursionsText"
        @beforeNextStep="resetExcursions"
      />
    </div>

    <div class="checkout-section__header">
      <h2 class="checkout-section__title">{{data.excursions.title}}</h2>
      <div class="checkout-section__description" v-html="data.excursions.descriptionHtml"></div>
    </div>

    <div class="tour-excursions__wrapper">
      <div class="personalise-wrapper">
        <Excursion
          v-for="excursion in excursionData.excursions"
          :key="excursion.id"
          :excursion="excursion"
          :data="excursionData"
          :brand="data.brandNameFormatted"
        >
          <ul class="personalise__checkbox">
            <li v-for="passenger in quote.passengers" :key="passenger.id" class="default-checkbox">
              <label>
                <input
                  type="checkbox"
                  @change="togglePassengerExcursion(passenger, excursion)"
                  :checked="passengerHasExcursion(passenger, excursion)"
                />
                <span class="checkbox__label">{{passengerFullName(passenger)}}</span>
              </label>
            </li>
          </ul>
        </Excursion>
      </div>
    </div>

    <PriceBreakdown />

    <div class="checkout-section__footer">
      <NavButton :class="{ 'btn btn--outline-gray-color btn--outline-gray-color_sm js-modal resultCardMapTs': data.brandNameFormatted === Brand.Travelsphere }" :back="true" text="Back" @beforePrevStep="resetExcursions" />
      <NavButton @beforeNextStep="setExcursions" />
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Excursion from '@/vue/components/Tour/Excursion.vue';
import PriceBreakdown from './../Components/PriceBreakdown.vue';
import NavButton from './../Components/NavButton.vue';
import {Brand} from './../../../../brand.js';

export default {
  name: 'Excursions',

  components: {
    Excursion,
    PriceBreakdown,
    NavButton
  },

  data: function() {
    return {
      Brand
    };
  },

  computed: {
    ...mapState('checkout', [
      'quote',
      'data',
      'excursionData',
      'excursionVisited'
    ]),
    ...mapGetters('checkout', ['excursions', 'passengerHasExcursion']),
    ...mapGetters(['passengerFullName'])
  },

  created() {
    this.$store.dispatch('checkout/getExcursions').then(() => {
      this.$store.commit('checkout/excursionsVisited');
      this.$store.commit('checkout/setDonations', this.data);
      this.$store.commit('checkout/setFlights', this.data);

      // if there are no excursions move onto the next step
      if (!this.excursionData.excursions.length) {
        this.$store.commit('checkout/nextStep');
      } else {
        this.$store.commit('checkout/excursionsExist');
      }
    });
  },

  methods: {
    togglePassengerExcursion(passenger, excursion) {
      this.$store.commit('checkout/togglePassengerExcursion', {
        passenger,
        excursion
      });
    },

    setExcursions() {
      if (this.excursions.length) {
        this.$store.commit("checkout/setDataExcursions", this.data);
        this.$store.dispatch('checkout/excursions');
        this.$store.dispatch('checkout/handleExcursionChange');
        GTM.addExcursions(this.$store.state.checkout);
      }
    },

    resetExcursions() {
      this.$store.commit('checkout/resetExcursions');
      this.$store.dispatch('checkout/handleExcursionChange');
    }
  }
};
</script>
